import pRetry from 'p-retry';
export const RETRY_TIMEOUT_SECONDS = 120;
export const retry = (fn) => pRetry(fn, {
    maxRetryTime: RETRY_TIMEOUT_SECONDS * 1000,
    minTimeout: 1000,
    maxTimeout: 1500,
    forever: true,
});
